import React from 'react';

import { SvgProps } from 'components/UI/Svg/Svg';
import { Color } from 'modules/styles/colors';
import { SNavStyles } from './index';
import { getFillColor, getStrokeColor } from './utils';

export default (props: SvgProps | undefined) => {
  const getFill = getFillColor(
    props?.active,
    props?.activeFillColor,
    props?.disabled,
    props?.disabledColor,
    props?.color
  );
  const getStroke = getStrokeColor(
    props?.active,
    props?.activeStrokeColor,
    props?.disabled,
    props?.disabledColor,
    props?.color
  );

  return {
    svg: (
      <g
        {...SNavStyles}
        strokeWidth={props?.active ? '1px' : '2px'}
        fill={getFillColor(
          props?.active,
          props?.activeFillColor,
          props?.disabled,
          Color.grayHue5,
          Color.graySidebarIcon
        )}
        stroke={getStrokeColor(props?.active, Color.primaryDark, props?.disabled, 'none', 'none')}
      >
        <path d="M26.25,7.06v1.55H9.75V7.06h4.13c0,0-0.53-3.06,4.13-3.06c4.67,0,4.13,3.06,4.13,3.06H26.25z" />
        <g {...SNavStyles} strokeWidth="2px" fill={getFill} stroke={getStroke}>
          <path
            d="M28.39,31.16H7.61c-0.09,0-0.17-0.08-0.17-0.17V11.02c0-0.09,0.08-0.17,0.17-0.17h20.77
                    c0.09,0,0.17,0.08,0.17,0.17v19.97C28.56,31.08,28.48,31.16,28.39,31.16z"
          />
        </g>
        <g
          {...SNavStyles}
          strokeWidth="2px"
          fill={getFill}
          stroke={getStrokeColor(
            props?.active,
            Color.white,
            props?.disabled,
            Color.grayHue5,
            Color.graySidebarIcon
          )}
        >
          <line x1="12.21" y1="16.9" x2="23.67" y2="16.9" />
          <line x1="12.27" y1="21" x2="23.73" y2="21" />
          <line x1="12.27" y1="25.11" x2="18" y2="25.11" />
        </g>
      </g>
    ),
    viewBox: '0 0 36 36'
  };
};
